<template lang="html">
  <div>
    <vs-card v-if="!displayForm" class="cardx card-100-h">
      <div>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
            <div v-if="!item">
              <vs-table stripe search :data="zones">
                <template v-if="!partner_namespace" slot="header">
                  <vs-row style="margin-bottom: 20px">
                    <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
                      <div style="margin-top: 10px; margin-bottom: 10px">
                        <vs-button
                          @click="addZone"
                          color="primary"
                          type="filled"
                          icon="add"
                          >Add new</vs-button
                        >
                      </div>
                    </vs-col>
                  </vs-row>
                </template>

                <template slot="thead">
                  <vs-th sort-key="name"> Name </vs-th>
                  <vs-th sort-key="type"> Type </vs-th>
                  <vs-th sort-key="status"> Actions </vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="item.id" v-for="item in data">
                    <vs-td>
                      <p class="cursor-pointer" v-on:click="showZone(item)">
                        {{ item.name }}
                      </p>
                    </vs-td>
                    <vs-td>
                      {{ item.type }}
                    </vs-td>
                    <vs-td style="width: 110px">
                      <feather-icon
                        icon="EditIcon"
                        @click="editZone(item)"
                        class="cursor-pointer navbar-fuzzy-search mr-4"
                      />
                      <feather-icon
                        icon="Trash2Icon"
                        @click="openConfirm(item)"
                        class="cursor-pointer navbar-fuzzy-search mr-4"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
            <div v-else>
              <h3 style="margin-bottom: 10px">{{ formTitle }}</h3>
              <div class="mb-4">
                <vs-input
                  class="inputx"
                  label="Name"
                  placeholder="Name"
                  v-model="item.name"
                  style="width: 100%"
                />
              </div>
              <div class="mb-4">
                <label class="vs-input--label">Type</label>
                <v-select
                  v-model="item.type"
                  name="partner"
                  v-validate="'required'"
                  :class="errors.has('type') ? 'danger' : ''"
                  :options="types"
                  :reduce="(el) => el.value"
                  label="text"
                />
              </div>

              <div class="mb-4">
                <vs-checkbox v-model="item.is_active">Enable</vs-checkbox>
              </div>
              <div class="mb-4">
                <vs-button
                  class="mr-3"
                  @click="saveZone"
                  color="danger"
                  type="filled"
                  >Guardar</vs-button
                >
                <vs-button @click="cancel" color="primary" type="filled"
                  >Cancelar</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>

    <!-- Mapa usando Leaflet -->
    <vs-card
      class="cardx card-100-h"
      v-bind:style="{ height: windowHeight - 155 + 'px' }"
    >
      <div>
        <vs-row>
          <vs-col
            v-if="displayForm"
            vs-lg="6"
            vs-sm="6"
            vs-xs="12"
            style="padding: 10px"
          >
            <div v-if="!item">
              <vs-table
                stripe
                search
                :data="zones"
                :maxHeight="windowHeight - 190 - 90 + 'px'"
              >
                <template slot="thead">
                  <vs-th sort-key="eco">Name</vs-th>
                  <vs-th sort-key="status">Actions</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="item.id" v-for="item in data">
                    <vs-td>
                      <p class="cursor-pointer" v-on:click="showZone(item)">
                        {{ item.name }}
                      </p>
                    </vs-td>
                    <vs-td style="width: 110px">
                      <feather-icon
                        icon="EditIcon"
                        @click="editZone(item)"
                        class="cursor-pointer navbar-fuzzy-search mr-4"
                      />
                      <feather-icon
                        icon="Trash2Icon"
                        @click="openConfirm(item)"
                        class="cursor-pointer navbar-fuzzy-search mr-4"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>

            <div v-else>
              <h3 style="margin-bottom: 10px">{{ formTitle }}</h3>
              <div class="mb-4">
                <vs-input
                  class="inputx"
                  label="Name"
                  placeholder="Name"
                  v-model="item.name"
                  style="width: 100%"
                />
              </div>
              <div class="mb-4">
                <label class="vs-input--label">Type</label>
                <v-select
                  v-model="item.type"
                  name="partner"
                  v-validate="'required'"
                  :class="errors.has('type') ? 'danger' : ''"
                  :options="types"
                  :reduce="(el) => el.value"
                  label="text"
                />
              </div>

              <div class="mb-4">
                <vs-input
                  class="inputx"
                  label="URL Map"
                  placeholder="https://..."
                  v-model="item.map_url"
                  style="width: 100%"
                  name="map_url"
                />
              </div>

              <div class="mb-4">
                <vs-input
                  class="inputx"
                  label="Cost Rent Vehicle"
                  placeholder="0.0"
                  v-model="item.cost_rent_vehicle"
                  style="width: 100%"
                  name="cost_rent_vehicle"
                  type="number"
                />
              </div>

              <div class="mb-4">
                <vs-checkbox v-model="item.is_active">Enable</vs-checkbox>
              </div>
              <div class="mb-4">
                <vs-button
                  class="mr-3"
                  @click="saveZone"
                  color="danger"
                  type="filled"
                  >Guardar</vs-button
                >
                <vs-button @click="cancel" color="primary" type="filled"
                  >Cancelar</vs-button
                >
              </div>
            </div>
          </vs-col>

          <vs-col
            vs-justify="center"
            vs-align="center"
            :vs-lg="displayForm ? '6' : '12'"
            vs-sm="6"
            vs-xs="12"
          >
            <div>
              <!-- Leaflet Map -->
              <LMap
                :zoom="8"
                :center="[center.lat, center.lng]"
                style="height: calc(100vh - 185px); margin: 10px"
              >
                <!-- Capa de OpenStreetMap -->
                <LTileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="&copy; OpenStreetMap contributors"
                />

                <!-- Polígonos de las zonas -->
                <LPolygon
                  v-for="zone in zonePolygons"
                  :key="zone.id"
                  :lat-lngs="zone.geofences"
                  :color="'blue'"
                />

                <!-- Polígono editable -->
                <LPolygon
                  v-if="item"
                  :lat-lngs="path"
                  :editable="true"
                  @edit="updateEdited"
                />
              </LMap>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<style scoped>
.card-100-h {
  height: calc(100% - 110px);
}
.mr-3 {
  margin-right: 3rem;
}
.mb-2 {
  margin-bottom: 2rem;
}
.mb-4 {
  margin-bottom: 4rem;
}
</style>

<script>
import { LMap, LTileLayer, LPolygon } from "vue2-leaflet";
import "leaflet/dist/leaflet.css"; // Importar estilos de Leaflet
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "ZoneList",
  components: {
    LMap,
    LTileLayer,
    LPolygon,
  },
  data() {
    return {
      windowHeight: 0,
      center: { lat: 19.41266, lng: -99.141134 }, // Centro del mapa
      polygons: [],
      item: null,
      formTitle: "",
      items: [],
      path: [],
      types: [
        { value: "PUBLIC", text: "Public" },
        { value: "PRIVATE", text: "Private" },
      ],
      displayForm: false,
    };
  },
  computed: {
    ...mapGetters("users", ["userCan"]),
    ...mapState("zones", ["zones"]),
    zonePolygons() {
      return this.zones.map((item) => {
        return {
          id: item.id,
          geofences: item.geofences.map((el) => [el[0], el[1]]),
        };
      });
    },
  },
  created() {},
  watch: {
    windowHeight(newHeight, oldHeight) {
      this.txt = `it changed to ${newHeight} from ${oldHeight}`;
    },
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions("zones", [
      "fetchZones",
      "storeZone",
      "updateZone",
      "deleteZone",
    ]),
    fetchData() {
      if (!this.userCan("zones.read")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      this.fetchZones({ limit: 400 }).catch((error) => {});
    },
    addZone() {
      this.formTitle = "Add";
      this.item = {
        name: null,
        is_active: false,
        geofences: [],
        type: "PUBLIC",
      };
      this.displayForm = true;
    },
    async saveZone() {
      let result = await this.$validator.validateAll();
      if (!result || this.onSubmit) {
        return;
      }
      this.onSubmit = true;

      this.$vs.loading({ type: "point" });

      if (this.item.hasOwnProperty("id")) {
        if (!this.userCan("zones.update")) {
          this.$vs.notify({
            color: "danger",
            title: `Error`,
            text: "You need permission to perform this action",
          });
          return;
        }

        this.updateZone(this.item)
          .then((data) => {
            this.$vs.loading.close();
            this.onSubmit = false;
            this.fetchData();
            this.cancel();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.onSubmit = false;
          });
      } else {
        if (!this.userCan("zones.create")) {
          this.$vs.notify({
            color: "danger",
            title: `Error`,
            text: "You need permission to perform this action",
          });
          return;
        }

        this.storeZone(this.item)
          .then((data) => {
            this.$vs.loading.close();
            this.onSubmit = false;
            this.fetchData();
            this.cancel();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.onSubmit = false;
          });
      }
    },
    editZone(zone) {
      this.formTitle = "Edit";
      this.item = _.cloneDeep(zone);
      this.displayForm = true;
      this.path = zone.geofences.map((el) => [el[0], el[1]]);
    },
    updateEdited(event) {
      const paths = event.target
        .getLatLngs()[0]
        .map((latlng) => [latlng.lat, latlng.lng]);
      this.item.geofences = paths;
    },
    openConfirm(zone) {
      if (!this.userCan("zones.delete")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this record? This cannot be undone!",
        accept: () => {
          this.deleteZone(zone).then((data) => {
            this.fetchData();
          });
        },
      });
    },
    cancel() {
      this.item = null;
      this.path = [];
      this.displayForm = false;
    },
    showZone(zone) {
      const bounds = L.latLngBounds(zone.geofences);
      this.$refs.mapRef.mapObject.fitBounds(bounds);
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
  },
};
</script>
